import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NzTSType} from 'ng-zorro-antd/core/types';
import {NzProgressStrokeColorType} from 'ng-zorro-antd/progress/typings';

@Component({
  selector: 'app-capacity-info',
  templateUrl: './capacity-info.component.html',
  styleUrls: ['./capacity-info.component.less']
})
export class CapacityInfoComponent implements OnInit {
  PLANS_PREFIX = 'PAGE.MOBILE.END_USERS.OVERVIEW.TELECOM_SERVICES.';

  @Input() capacityTitle: string;
  @Input() capacityTitleTooltip: NzTSType | null;
  @Input() capacityData: string;
  @Input() capacityPercentage: number;
  @Input() progressBarColor: NzProgressStrokeColorType;
  @Input() progressBarTooltip: string | TemplateRef<any>;
  @Input() progressBarSize: 'default' | 'small' = 'default';
  @Input() consumedData: string;
  @Input() isUnlimited: boolean;
  @Input() hasTooltip: boolean;
  @Input() capacityType: 'data' | 'voice' | 'sms' | 'icons' | 'noSupport';
  @Input() noSupportText: string;

  constructor(
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
  }

}
